import { Tooltip, Zoom, Box } from '@mui/material';
import type { SxProps } from '@mui/material';
import type { ReactNode } from 'react';
import { InformationIcon } from '../icons';
import theme from '../../theme';

export const InformationTooltip = (props: {
    title: ReactNode;
    sx?: SxProps;
    iconSx?: SxProps;
}) => {
    return (
        <Tooltip
            sx={props.sx}
            title={props.title}
            arrow
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 250 }}
        >
            <Box
                sx={{
                    verticalAlign: 'middle',
                    display: 'inline-flex',
                    alignItems: 'center',
                }}
            >
                <InformationIcon
                    size={18}
                    color={theme.color.blue}
                    sx={props.iconSx}
                />
            </Box>
        </Tooltip>
    );
};
